import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { api } from "../../api/client";
import { qk } from "../../api/queries";
import type { Task } from "../../api/types";
import { Icon } from "../Icon";

export function NewTaskInline({
  pid,
  onOpenForm,
  onCreated,
}: {
  pid: string;
  onOpenForm: () => void;
  onCreated: (t: Task) => void;
}) {
  const [editing, setEditing] = useState(false);
  const [title, setTitle] = useState("");
  const qc = useQueryClient();
  const create = useMutation({
    mutationFn: (t: string) => api.createTask(pid, { title: t, description: "", acceptance_criteria: "" }),
    onSuccess: (task) => {
      setTitle("");
      qc.invalidateQueries({ queryKey: qk.tasks(pid) });
      onCreated(task);
    },
  });

  if (!editing) {
    return (
      <div className="new-task-inline">
        <button className="btn btn-primary btn-block" onClick={() => setEditing(true)}>
          <Icon name="plus" size={14} /> New task
        </button>
      </div>
    );
  }
  return (
    <form
      className="new-task-inline card"
      onSubmit={(e) => {
        e.preventDefault();
        if (title.trim()) create.mutate(title.trim());
      }}
    >
      <input
        className="input input-bare"
        autoFocus
        placeholder="Task title, then Enter"
        value={title}
        disabled={create.isPending}
        onChange={(e) => setTitle(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            setEditing(false);
            setTitle("");
          }
        }}
        onBlur={() => !title.trim() && setEditing(false)}
      />
      <div className="new-task-inline-actions">
        <button type="button" className="btn btn-ghost btn-sm" onMouseDown={(e) => e.preventDefault()} onClick={onOpenForm}>
          Full form…
        </button>
        <button className="btn btn-primary btn-sm" disabled={!title.trim() || create.isPending}>
          Create
        </button>
      </div>
    </form>
  );
}
